import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subscription } from 'rxjs';
import { tap } from 'rxjs/operators';

import { Const } from '../const';

import { DashboardApiParameter } from '../servicer/models/dashboard-api-parameter';
import { DashboardApiResponse } from '../servicer/models/dashboard-api-response';

import { VehicleServiceProvider } from '../servicer/vehicle-service';

/**
 * ダッシュボードを定期間隔で取得するプロバイダー.
 */
@Injectable()
export class IntervalReceiverProvider {
  /** ダッシュボードの空のレスポンス. */
  private readonly dashboardEmptyResponse = {
    result: Const.ResponseResult.SUCCESS,
    message: '',
    user_info: [],
    dashboard: []
  } as DashboardApiResponse;

  /** ダッシュボード情報. */
  public dashboardInfos$: BehaviorSubject<DashboardApiResponse> = new BehaviorSubject<DashboardApiResponse>(this.dashboardEmptyResponse);
    
  /** インターバルのSubscription. */
  private intervalSubscription: Subscription = null;

  constructor(
    public vehicleService: VehicleServiceProvider
  ) { }

  /**
   * 開始.
   *
   * @param parameter ダッシュボードパラメータ
   */
  start(parameter: DashboardApiParameter) {
    // 初回のダッシュボード取得
    this.getDashboardInfos(parameter).subscribe(() => {
      let processing = false;

      this.intervalSubscription = Observable.interval(1000)
        .filter(() => !processing)
        .pipe(tap(() => processing = true))
        .flatMap(() => this.getDashboardInfos(parameter))
        .pipe(tap(() => processing = false))
        .subscribe();
    });
  }

  /**
   * 停止.
   */
  stop() {
    this.dashboardInfos$.next(this.dashboardEmptyResponse);

    if (this.intervalSubscription) {
      this.intervalSubscription.unsubscribe();
      this.intervalSubscription = null;
    }
  }

  /**
   * ダッシュボード表示情報を取得します.
   * 定期的に呼び出されるため、エラーが発生しても、何も処理をしません.
   *
   * @param parameter ダッシュボードパラメータ
   */
  private getDashboardInfos(parameter: DashboardApiParameter): Observable<DashboardApiResponse> {
    return this.vehicleService.postDashboardRequest(parameter)
      .map((response) => {
        if (response.result === Const.ResponseResult.SUCCESS) {
          this.dashboardInfos$.next(response);
        }

        return this.dashboardInfos$.value;
      })
      .catch(() => Observable.of(this.dashboardInfos$.value));
  }
}



// WEBPACK FOOTER //
// ./src/providers/interval-receiver/interval-receiver.ts